module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABJUlEQVQ4T+WTv0rDUBTGv69m0IKi4OBowQcoJm4KFnr9A4n0LXRx9ClcBXFydC0mojaBCrqZlD6AoIOjoChUh9gjMSq9sZAsTt7tnO/c3/nDOUTmNc+u68ZIyc/6Ezt+76vG2kIwqDEb6LrhNEe5ScAY1ASI5U0OHMd60ABeKzoCZWZYxlyf8J5eEB1COCuQKoHJ3E8ABHgi2AXl7qcFz++0AVkuAgB4Yav5WhL7VwDp9h5flspTE7dJlp7xXCnH45cAq2mFuRWkAV4r+gTYK2ZFb/E/ANIhjn0N8bXYEKNk/+vF9gCBrUyl7cGJ39kXyFZBwJ6tzG0NcHwaLpYMtAFqR/QbKHE/Rm1j3brSAInhnocNkLsk5oZVIoIbiOw4q1bzW/8AicmtyyUMRdkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sources/del.png
// module id = 6Q8e
// module chunks = 96